import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <Seo title="Privacy Policy" description="Privacy Policy for Domaleo Enterprise." />
      <section className="relative overflow-hidden pt-32 pb-16 lg:pt-40 lg:pb-20">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1695668548342-c0c1ad479aee?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920" alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 hero-overlay" />
        </div>
        <div className="relative container-px mx-auto max-w-4xl">
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-white">Privacy Policy</h1>
          <p className="mt-3 text-slate-200">How Domaleo Enterprise collects, uses and protects your information.</p>
        </div>
      </section>
      <section className="container-px mx-auto max-w-4xl py-16 lg:py-24">
        <Reveal className="prose-domaleo space-y-8 text-muted-foreground leading-relaxed">
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground">Information We Collect</h2>
            <p className="mt-3">We collect information you provide directly to us, such as your name, email, phone number, company and message when you submit a contact form or subscribe to our newsletter.</p>
          </div>
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground">How We Use Your Information</h2>
            <p className="mt-3">We use your information to respond to inquiries, provide quotes, deliver our services, and send updates you have requested. We do not sell your personal data to third parties.</p>
          </div>
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground">Data Security</h2>
            <p className="mt-3">We implement reasonable security measures to protect your information against unauthorised access, alteration or disclosure.</p>
          </div>
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground">Contact</h2>
            <p className="mt-3">For privacy questions, contact us at info@domaleo.com.</p>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
